import { ObjectiveGroup, StudyEntityType } from '@faro/study-designer-model';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { objectiveGroupClient, ObjectiveGroupPathParameters } from './ObjectiveGroupClient';

const factory = createStudyEntityHookFactory<ObjectiveGroup, ObjectiveGroupPathParameters>(
    StudyEntityType.ObjectiveGroup
);

export const useObjectiveGroups = factory.list(objectiveGroupClient.list);
export const useObjectiveGroup = factory.get(objectiveGroupClient.get);
